export const containerStyle = {
  width: "100%", // Full width by default
  maxWidth: { sm: "600px" }, // Limit width on larger screens
  height: "auto", // Adjust height automatically
  margin: "0 auto", // Center the chart
}
